// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1c_Lh","left":"styles_left__3CAkq"};